/**
 * @author Manne Hareesh
 * @description Reducer for the components in Category page
 */
 import {
    SET_RUNNING_CACHE,
    SET_LOGIN_USER_DETAILS,
    LOG_OUT_ACTION,
    SET_SERVER_URL,
    SET_PREPAID_OTA_AGENT_ID, SET_PREPAID_OTA_TRAVELS_ID
 } from '../actions/action-types';
import {
    isValidArray,
    setLocalStorage,
    setAgentPortalColors,
    isValid,
    getArrayfromString
} from './../utils/utilities';

import { 
    AGENT_COLORS_ACCESS_TOKEN_KEY,
    SERVER_URL_ACCESS_TOKEN_KEY,
    DAFIDY_OPERATOR_CODE
} from './../utils/constant';
import { API_ADMIN_URL, API_TRAVELS_URL } from '../app.config';

const getNumbers=(userDetails)=>{
    let phoneNumber = null;
    let landlineNumber = null;
    if(isValid(userDetails.travels_details)&&isValid(userDetails.travels_details.phone_number)){
        let phoneNumberArray = getArrayfromString(userDetails.travels_details.phone_number);
        phoneNumber=phoneNumberArray[0];
        landlineNumber=phoneNumberArray[1];
    }
    return {
        phoneNumber,
        landlineNumber
    }
}
  
const setGlobalVariables=(userDetails)=>{
    let tripSheetBold = '';
    if(isValid(userDetails.tripSheetConfig)){
        if(userDetails.tripSheetConfig['show_table_content_as_bold'] == 1){
            tripSheetBold = 'tripSheetBold';
        }
    }
    global.operatorCode=userDetails.operator_code;
    // DAFIDY agents book across every operator, so a trip belonging to another
    // operator is a normal booking for them and not a shared service.
    global.isMultiOperatorAgent = userDetails.operator_code === DAFIDY_OPERATOR_CODE;
    global.travelsId=userDetails.travels_id;
    global.operatorName=userDetails.operator_name;
    global.agentId=userDetails.id;
    global.userName=userDetails.user_name;
    global.allowedActions=userDetails.allowedActions;
    global.privilege=userDetails.privilege;
    global.webSiteUrl=userDetails.website_url;
    global.name=userDetails.name;
    const travelsDetails = userDetails.travels_details || {};
    global.logoUrl = travelsDetails.agent_portal_logo;
    if(isValid(travelsDetails.print_logo)){
        global.printLogo = travelsDetails.print_logo;
    }else{
        global.printLogo = travelsDetails.agent_portal_logo;
    }
    global.accessCode = userDetails.access_code;
    global.useRemarks = userDetails.use_remarks ;
    global.googleMapsApi = userDetails.GOOGLE_MAPS_API;
    global.tripSheetConfig = userDetails.tripSheetConfig;
    global.overdueAmount = userDetails.overdue_amount;
    global.tripSheetBold = tripSheetBold;
    global.dynamicPricingEnabled = userDetails.dynamic_pricing_enabled;
    global.dynamicPricingProvider = userDetails.dynamic_pricing_provider;
    global.travelsPhoneNumber = userDetails.travelsPhoneNumber;
    global.adminClientUrl = userDetails.admin_client_url;
    global.cancellation_penality_percentage = userDetails.cancellation_penality_percentage;
    global.displayName = userDetails.display_name;
    global.send_payment_link = userDetails.send_payment_link;
    global.travelsDetails = userDetails.travels_details;
    global.agentType = userDetails.agent_type;
    global.amountLimit = userDetails.amount_limit;
    global.amountDue = userDetails.amount_due;
    // Present only for registered OTA partner agents (ota_partner registry);
    // drives partner-specific UI without hardcoded agent checks.
    global.otaPartnerConfig = userDetails.otaPartnerConfig;
    global.travelsAppConfig = isValid(userDetails.travels_details)&&isValid(userDetails.travels_details.travels_app_config)?userDetails.travels_details.travels_app_config:{};
    let agentPortalColors = userDetails.agentPortalColors;
    global.tooltipFieldConfigs = userDetails.tooltipFieldConfigs;
    let {
        phoneNumber,
        landlineNumber
    } = getNumbers(userDetails);
    global.phoneNumber = phoneNumber;
    global.landlineNumber = landlineNumber;
    
    if(isValidArray(agentPortalColors)){
        setLocalStorage(AGENT_COLORS_ACCESS_TOKEN_KEY,JSON.stringify(agentPortalColors));
        setAgentPortalColors(agentPortalColors);
    }
}

  const initialState = {
      user: {
          userName:null,
          phoneNumber:null,
          operatorCode:null,
          operatorName:null,
          travelsId:null,
          privilege:null,
          name:null,
          location:null,
          accessCode:null,
          webSiteUrl:null,
          googleMapsApi: null,
          tripSheetConfig :null,
          displayName: null
      },
      runSplashScreen:true,
      isLoggedIn:false,
      travelsDetails:null,
      serverUrl:null,
      prepaidOtaIdsByServer: {
        srmsAgentId:null,
        northAgentId:null,
        b2bAgentId:null,
        srmsTravelsId:null,
        northTravelsId:null,
        b2bTravelsId:null
      }
  }
  
  export const userReducer = (state = initialState,action) => {
      let newState = Object.assign({},state);
      switch (action.type) {  

         case SET_LOGIN_USER_DETAILS:
             let userDetails=action.payload;
             let formatedUser={
                userName:userDetails.user_name,
                phoneNumber:userDetails.phone_number,
                operatorCode:userDetails.operator_code,
                operatorName:userDetails.operator_name,
                travelsId:userDetails.travels_id,
                privilege:userDetails.privilege,
                name:userDetails.name,
                location:userDetails.location,
                accessCode:userDetails.access_code,
                webSiteUrl:userDetails.website_url,
                adminClientUrl:userDetails.admin_client_url,
                logoUrl:userDetails.logo_url,
                printLogo:userDetails.print_logo,
                useRemarks:userDetails.use_remarks,
                googleMapsApi: userDetails.GOOGLE_MAPS_API,
                tripSheetConfig: userDetails.tripSheetConfig,
                travelsPhoneNumber:userDetails.travelsPhoneNumber,
                cancellation_penality_percentage:userDetails.cancellation_penality_percentage,
                displayName: userDetails.display_name
             }
             
            newState.user=formatedUser;
            newState.partnerDetails = userDetails.partnerDetails;
            newState.isLoggedIn=true;
            newState.travelsDetails = userDetails.travels_details;
            setGlobalVariables(userDetails);
            return newState;

         case SET_RUNNING_CACHE:
             newState.runSplashScreen=action.payload;
             return newState;

        case SET_SERVER_URL:
            let serverUrl= action.payload;
            let travelsServerUrl = API_TRAVELS_URL;
            let adminServerUrl = API_ADMIN_URL;
            if(isValid(serverUrl)){
                travelsServerUrl = serverUrl.travels_server_url;
                adminServerUrl = serverUrl.admin_server_url;
            }
            let formattedServerUrl = {
                travels_server_url:travelsServerUrl,
                admin_server_url:adminServerUrl
            }
            setLocalStorage(SERVER_URL_ACCESS_TOKEN_KEY,JSON.stringify(formattedServerUrl));
            global.serverUrl = formattedServerUrl;
            newState.serverUrl = formattedServerUrl;
            return newState;

        case SET_PREPAID_OTA_AGENT_ID: {
            let server = action.payload.server;
            let agentId = action.payload.agentId;
            switch (server) {
                case 'srms':
                    newState.prepaidOtaIdsByServer.srmsAgentId = agentId;
                    break;
                case 'north':
                    newState.prepaidOtaIdsByServer.northAgentId = agentId;
                    break;
                case 'b2b':
                    newState.prepaidOtaIdsByServer.b2bAgentId = agentId;
                    break;
            }
            return newState;
        }

        case SET_PREPAID_OTA_TRAVELS_ID: {
            let server = action.payload.server;
            let travelsId = action.payload.travelsId;
            switch (server) {
                case 'srms':
                    newState.prepaidOtaIdsByServer.srmsTravelsId = travelsId;
                    break;
                case 'north':
                    newState.prepaidOtaIdsByServer.northTravelsId = travelsId;
                    break;
                case 'b2b':
                    newState.prepaidOtaIdsByServer.b2bTravelsId = travelsId;
                    break;
            }
            return newState;
        }

        case LOG_OUT_ACTION :
            return initialState;
  
          default:
              return state;
      }
  }
  